<template>
  <div class="km__modules__color--area-outline-pattern-select">
    <ColorAreaOutlinePatternButtons
        :active-area-color-object="activeAreaColorObject"
        :outline-for-active-area-color-object="outlineForActiveAreaColorObject"
        @setColorObjectToEdit="ccode=>$emit('setColorObjectToEdit', ccode)"
        @openpatterncolors="$emit('openpatterncolors')"
        @openpatterncategories="$emit('openpatterncategories')"
        :may_have_pattern="may_have_pattern"
    />
  </div>
</template>

<script lang="ts" setup>

import {AnimationWaitingForTargetFactory, KeyFrameTargetValues} from "@km/animations/animationFactory";
import ColorAreaOutlinePatternButtons from "@km/components/color/ColorAreaOutlinePatternButtons.vue";
import {useStore} from "vuex";
import {setWatchToAnimateOnStatechange} from "@km/js/animater";
import type {Color} from "@k/js/colorObject";
import {useModuleColorOpenStateStore} from "@km/store/frontendstate/useModuleColorOpenState";

const props = defineProps<{
  activeAreaColorObject: Color|null;
  outlineForActiveAreaColorObject: Color|null;
  may_have_pattern: (designname: string) => boolean;
}>();


const upDownAnimation = AnimationWaitingForTargetFactory.getUpDownAnimation(".km__modules__color--area-outline-pattern-select");
const keyframes = new KeyFrameTargetValues(0, 165);
const store = useStore();
const openStateStore=  useModuleColorOpenStateStore();
setWatchToAnimateOnStatechange(upDownAnimation, keyframes, () => openStateStore.getAreaOutlinePatternState);
</script>


<style lang="scss" scoped>
@use "../../scss/settings/config" as config;

.km__modules__color--area-outline-pattern-select {
  position: fixed;
  height: 155px;
  width: 100%;
  bottom: 45px;
  left: 0;
  z-index: 5;
  background: config.$color-white;
  padding: 30px 10px 5px 10px;
  transform: translate(0, 180px);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
</style>
